/*
 * WsPredictiveSearch — erweitert Dawn's PredictiveSearch
 * - Fetch geht an unsere eigene Section ws-predictive-search (statt Dawn-default)
 * - Filtert Ressourcen auf Produkte + Kollektionen (kein Overhead für Pages/Articles/Queries)
 * - Startet ab 2 Zeichen (Dawn's onChange feuert bei 1 Zeichen; wir short-circuiten)
 *
 * Guard: falls PredictiveSearch (parent) noch nicht geladen ist, wird die Klasse
 * nicht definiert. Verhindert ReferenceError bei kaputter Ladereihenfolge.
 */
// Wildcard-Suffix pro Wort: "guc" → "guc*", "silh sonnen" → "silh* sonnen*"
// Löst Anfangsbuchstaben-Fälle (Shopify's Default macht kein Prefix-Match).
// Top-level, damit auch die Submit-Delegation unten sie nutzen kann —
// unabhängig davon, ob die Klassen-Registrierung (Guard) durchläuft.
function wsBuildWildcardQuery(term) {
  return term
    .trim()
    .split(/\s+/)
    // Führendes "-" ist Shopifys NOT-Operator: aus dem alleinstehenden "-" in
    // Titeln wie "… Kontaktlinsen-Pflege - 360ml" würde "-*" → 0 Treffer.
    // Deshalb Minuszeichen am Wortanfang strippen und Tokens ohne
    // Buchstaben/Ziffern (z.B. "-", "•") komplett verwerfen.
    .map((word) => word.replace(/^-+/, ''))
    .filter((word) => /[\p{L}\p{N}]/u.test(word))
    .map((word) => (word.endsWith('*') ? word : word + '*'))
    .join(' ');
}

if (typeof PredictiveSearch === 'undefined') {
  console.warn('[ws-predictive-search] PredictiveSearch parent class not loaded — skipping registration. Check that predictive-search.js is loaded before ws-predictive-search.js.');
} else {
class WsPredictiveSearch extends PredictiveSearch {
  static MIN_QUERY_LENGTH = 2;

  static buildWildcardQuery(term) {
    return wsBuildWildcardQuery(term);
  }

  constructor() {
    super();
    // Cache-Sharing über alle WS-Instanzen (Dawn hardcoded 'predictive-search', wir brauchen unser Tag)
    this.allPredictiveSearchInstances = document.querySelectorAll('ws-predictive-search');
  }

  onChange() {
    // Reset-Button Toggle (aus SearchForm), aber wir haben keinen → Guard.
    if (this.resetButton) {
      const resetIsHidden = this.resetButton.classList.contains('hidden');
      if (this.input.value.length > 0 && resetIsHidden) {
        this.resetButton.classList.remove('hidden');
      } else if (this.input.value.length === 0 && !resetIsHidden) {
        this.resetButton.classList.add('hidden');
      }
    }

    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    if (this.searchTerm.length < WsPredictiveSearch.MIN_QUERY_LENGTH) {
      this.close();
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const params = new URLSearchParams({
      q: WsPredictiveSearch.buildWildcardQuery(searchTerm),
      section_id: 'ws-predictive-search',
      'resources[type]': 'product,collection',
      'resources[limit]': 6,
      'resources[limit_scope]': 'each',
    });

    fetch(`${routes.predictive_search_url}?${params.toString()}`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const container = parsed.querySelector('#shopify-section-ws-predictive-search');
        const resultsMarkup = container ? container.innerHTML : '';
        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) return;
        this.close();
        throw error;
      });
  }
}

customElements.define('ws-predictive-search', WsPredictiveSearch);
}

// Unsichtbare Wildcard-Anreicherung beim echten Submit (Enter / Lupen-Button):
// "roy rob" wird als "roy* rob*" gesucht, ohne dass der Kunde Sternchen im
// Suchfeld sieht. Delegation auf document (Projekt-Konvention) — greift für
// die Header-Suche UND das Suchfeld auf der Suchergebnis-Seite.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
  // PredictiveSearch.onFormSubmit hat schon abgebrochen (leeres Feld /
  // Dropdown-Eintrag ausgewählt) → nicht dazwischenfunken
  if (event.defaultPrevented) return;
  const action = form.getAttribute('action') || '';
  const searchUrl = (typeof routes !== 'undefined' && routes.search_url) || '/search';
  if (!action.includes(searchUrl)) return;
  const input = form.querySelector('input[name="q"]');
  if (!input || !input.value.trim()) return;
  event.preventDefault();
  const params = new URLSearchParams(new FormData(form));
  params.set('q', wsBuildWildcardQuery(input.value));
  window.location.assign(`${action.split('?')[0]}?${params.toString()}`);
});

